import actions from './actions';
import initialState from '../initialState';

export const snackbarReducer = (state = initialState.snackbar, action) => {
    switch (action.type) {
        case actions.SNACKBAR_MESSAGE:
            return { ...state, ...action.state };
        default:
            return state;
    }
};

export default snackbarReducer;
